import { render, staticRenderFns } from "./afterLoginLayout.vue?vue&type=template&id=47541e55&scoped=true&"
import script from "./afterLoginLayout.vue?vue&type=script&lang=js&"
export * from "./afterLoginLayout.vue?vue&type=script&lang=js&"
import style0 from "./afterLoginLayout.vue?vue&type=style&index=0&id=47541e55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47541e55",
  null
  
)

export default component.exports